import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form/immutable';

import { reducer as routerReducer, routeMap } from 'router';

import { LOCATION_CHANGED } from 'redux-little-router';
import { actionTypes as logoutActionTypes } from 'modules/Authorization/redux/logout/actions';
import { authorizationReducers } from 'modules/Authorization/redux';
import { contactsReducers } from 'modules/Contacts/redux';
import { messagesReducers } from 'modules/Messages/redux';
import { newTaxesReducers } from 'modules/NewTaxes/redux';
import { paymentReducers } from 'modules/Payment/redux';
import { profileReducers } from 'modules/Profile/redux';
import { userIncomesReducers } from 'modules/UserIncomes/redux';
import { propertyObjectsReducers } from 'modules/PropertyObjects/redux';
import { tapsReducers } from 'modules/Taps/redux';
import { appReducers } from 'modules/App/redux';
import { checksReducer } from 'modules/Checks';
import configReducer from 'modules/ConfigWrapper/redux/reducer';
import appIsReadyCheckReducer from 'modules/AppIsReadyCheckWrapper/redux/reducer';
import notificationsReducer from 'modules/Notifications/redux';
import declarationsReducer from 'modules/Declarations/redux';

const mainReducer = combineReducers({
  form,
  app: combineReducers(appReducers),
  authorization: combineReducers(authorizationReducers),
  checks: checksReducer,
  config: configReducer,
  appIsReadyCheck: appIsReadyCheckReducer,
  contacts: combineReducers(contactsReducers),
  messages: combineReducers(messagesReducers),
  taxes: combineReducers(newTaxesReducers),
  payment: combineReducers(paymentReducers),
  profile: combineReducers(profileReducers),
  propertyObjects: combineReducers(propertyObjectsReducers),
  taps: combineReducers(tapsReducers),
  userIncomes: combineReducers(userIncomesReducers),
  router: (state, action) => {
    const nextState = routerReducer(state, action);

    if (nextState.queue.length > 1) {
      nextState.queue = nextState.queue.slice(-1);
    }

    return nextState;
  },
  notifications: notificationsReducer,
  declarations: declarationsReducer,
});

export const makeRootReducer = (state, action) => {
  if (action.type === logoutActionTypes.SUCCESS) {
    state = { app: { adminConfig: state.app.adminConfig } };
  }
  if (needClearStore(action)) {
    //todo: emikheev - exclude inspector data
    state = {
      app: {
        incomingData: state.app.incomingData,
        adminConfig: state.app.adminConfig,
      },
    };
  }

  return mainReducer(state, action);
};

function needClearStore(action) {
  return action.type === LOCATION_CHANGED && action.payload.route === routeMap.login;
}
